import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const getMttLobbyService = (params = {}) => {
  return axiosInstanceService(METHOD_TYPES.get, 'mtt/lobby', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.page,
    params
  })
}

export const registerMttService = ({ tournamentId }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'mtt/register', { tournamentId }, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit,
    showApiSuccessMessage: true
  })
}

export const unregisterMttService = ({ tournamentId }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'mtt/unregister', { tournamentId }, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit,
    showApiSuccessMessage: true
  })
}

export const getMttOverviewService = (tournamentId) => {
  return axiosInstanceService(METHOD_TYPES.get, `mtt/${tournamentId}/overview`, {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}

export const getMttResultsService = (tournamentId, params = {}) => {
  return axiosInstanceService(METHOD_TYPES.get, `mtt/${tournamentId}/results`, {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}
